import Skeleton from 'components/ui-new/skeleton/skeleton';
import s from './loading-skeleton.module.scss';

type Props = {
  count: number;
};

const LoadingSkeleton = ({ count }: Props) => {
  return (
    <>
      <div className={s.skeleton_heading}>
        Shown <span>{count}</span>
      </div>
      <div className={s.skeleton}>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_heading}>Hidden</div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
        <div className={s.skeleton_row}>
          <Skeleton variant="text" width="378px" height={24} />
        </div>
      </div>
    </>
  );
};

export default LoadingSkeleton;
